import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { SearchFacetRefinementCheckboxes } from '@uncinc/react-searchkit';

export interface SearchAllContentTypeFacetProps {
  className?: string;
}

const SearchAllContentTypeFacet: React.FC<SearchAllContentTypeFacetProps> = (props) => {
  const { className } = props;

  const { t } = useTranslation();

  const classNames = c('SearchAllContent__TypeFacet', className);

  return (
    <div className={classNames}>
      <h2 className="asH3 mb-8">
        {t('components.search_general.facets.type_title')}
      </h2>

      <SearchFacetRefinementCheckboxes
        attribute="type"
        transformItems={(items) => {
          // Normally, the items are sorted by the number of hits they have.
          // But in this case, we want Publications (biblio) followed by
          // Practical Materials, Online Courses and the rest.
          const publicationsItem = items.splice(items.findIndex((item) => item.value === 'biblio'), 1);
          const practicalMaterialItem = items.splice(items.findIndex((item) => item.value === 'practical_material'), 1);
          const onlineCourseItem = items.splice(items.findIndex((item) => item.value === 'online_course'), 1);
          const newsItems = publicationsItem.concat(practicalMaterialItem, onlineCourseItem, items);

          return newsItems.map((item) => ({
            ...item,
            label: t(`content_types.${item.value}.type`),
          }));
        }}
      />
    </div>
  );
};

export default SearchAllContentTypeFacet;
